import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function Cta() {
  return <section id="cta-section" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        <div className="bg-accent/30 border-border mx-auto max-w-4xl rounded-2xl border p-8 text-center shadow-sm md:p-16">
          <h2 className="font-default text-foreground mb-4 text-3xl font-bold md:text-4xl">
            {"Have a question or need assistance?"}
          </h2>
          <p className="text-muted-foreground mx-auto mb-8 max-w-2xl text-lg">
            {"Send us a contact inquiry and our team will get back to you as soon as possible to discuss how we can help."}
          </p>
          <Button asChild size="lg" className="rounded-lg">
            <Link to="/ContactUsPage">
              {"Contact Us"}
              <ArrowRight className="ml-2 size-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}